<template>
	<div class="col-12">
		<div class="Component">
			<h2 class="">
				{{ 'Participate in online Indigo Olympiad' | translate }}
			</h2>
			<a
				:href="`https://olymp.${olympPrefix}indigomental.com/`"
				target="_blank"
				class="btn btn-light font-weight-bold button"
			>
				{{ 'Participate' | translate }}
			</a>

			<svg
				class="calculator icon"
				width="46"
				height="42"
				viewBox="0 0 46 42"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M43.3595 23.9123L40.9981 24.926L31.1432 1.96834C30.9878 1.60613 30.5679 1.43849 30.2057 1.59397L27.582 2.72024C27.2198 2.87572 27.0522 3.29554 27.2076 3.65774L28.8971 7.59334L26.1903 8.75525C25.413 7.75024 24.0252 7.35425 22.8049 7.87808C21.5846 8.40191 20.9157 9.68078 21.1089 10.9365L19.631 11.5709C18.8537 10.5659 17.4659 10.1699 16.2456 10.6938C15.4625 11.0299 14.9071 11.6772 14.6603 12.4295C13.9449 12.0903 13.093 12.047 12.31 12.3832C11.0897 12.907 10.4208 14.1859 10.614 15.4416L9.21908 16.0404L7.52968 12.1048C7.3742 11.7426 6.95438 11.5749 6.59218 11.7304L3.96845 12.8567C3.60624 13.0122 3.4386 13.432 3.59408 13.7942L13.449 36.7518L11.0876 37.7655C10.7254 37.9209 10.5577 38.3407 10.7132 38.703L11.8395 41.3267C11.995 41.6889 12.4148 41.8565 12.777 41.701L45.0489 27.8479C45.4111 27.6924 45.5787 27.2726 45.4232 26.9104L44.297 24.2867C44.1415 23.9245 43.7217 23.7568 43.3595 23.9123ZM28.8011 3.75054L30.1129 3.1874L39.6862 25.4891L38.3744 26.0522L28.8011 3.75054ZM17.3845 35.0624L15.4136 30.4709L16.8085 29.8721C17.5857 30.877 18.9736 31.2731 20.1939 30.7493C21.4142 30.2254 22.083 28.9465 21.8899 27.6908L24.6797 26.4933C25.4569 27.4982 26.8448 27.8943 28.0651 27.3705C29.2854 26.8466 29.9542 25.5677 29.761 24.312L35.0915 22.0238L37.0625 26.6154L17.3845 35.0624ZM13.9928 23.3128C14.77 24.3177 16.1579 24.7138 17.3782 24.1899C18.5985 23.6661 19.2674 22.3872 19.0742 21.1315L25.7996 18.2446C26.5768 19.2495 27.9647 19.6456 29.185 19.1217C30.4053 18.5979 31.0741 17.319 30.881 16.0633L32.2759 15.4645L34.5284 20.712L29.1979 23.0002C28.4207 21.9952 27.0328 21.5992 25.8125 22.123C24.5922 22.6468 23.9234 23.9258 24.1165 25.1814L21.3267 26.379C20.5495 25.374 19.1616 24.978 17.9413 25.5018C16.721 26.0256 16.0522 27.3046 16.2453 28.5602L14.8504 29.159L12.5979 23.9116L13.9928 23.3128ZM14.9401 22.1294C14.6295 21.406 14.9654 20.5649 15.6888 20.2544C16.4121 19.9438 17.2533 20.2797 17.5638 21.0031C17.8743 21.7264 17.5384 22.5676 16.8151 22.8781C16.0917 23.1886 15.2506 22.8527 14.9401 22.1294ZM26.7468 17.0611C26.4363 16.3378 26.7722 15.4966 27.4956 15.1861C28.2189 14.8756 29.0601 15.2115 29.3706 15.9349C29.6811 16.6582 29.3452 17.4993 28.6218 17.8099C27.8985 18.1204 27.0574 17.7845 26.7468 17.0611ZM28.2507 24.1836C28.5612 24.907 28.2253 25.7481 27.5019 26.0586C26.7786 26.3691 25.9374 26.0332 25.6269 25.3099C25.3164 24.5865 25.6523 23.7454 26.3757 23.4349C27.099 23.1243 27.9401 23.4602 28.2507 24.1836ZM20.3795 27.5624C20.69 28.2858 20.3541 29.1269 19.6307 29.4374C18.9074 29.7479 18.0662 29.412 17.7557 28.6887C17.4452 27.9653 17.7811 27.1242 18.5045 26.8137C19.2278 26.5032 20.069 26.839 20.3795 27.5624ZM23.368 9.18994C24.0914 8.87943 24.9325 9.21531 25.243 9.93867C25.5535 10.662 25.2177 11.5032 24.4943 11.8137C23.7709 12.1242 22.9298 11.7883 22.6193 11.0649C22.3088 10.3416 22.6447 9.50046 23.368 9.18994ZM16.8087 12.0056C17.5321 11.6951 18.3732 12.031 18.6837 12.7544C18.9942 13.4777 18.6583 14.3188 17.935 14.6294C17.2116 14.9399 16.3705 14.604 16.06 13.8806C15.7495 13.1573 16.0853 12.3161 16.8087 12.0056ZM12.8731 13.695C13.5965 13.3845 14.4376 13.7204 14.7481 14.4438C15.0586 15.1671 14.7227 16.0082 13.9994 16.3188C13.276 16.6293 12.4349 16.2934 12.1244 15.57C11.8139 14.8467 12.1497 14.0055 12.8731 13.695ZM11.1771 16.7534C11.9544 17.7585 13.3422 18.1544 14.5625 17.6306C15.3456 17.2945 15.901 16.6472 16.1478 15.8948C16.8632 16.2341 17.7151 16.2774 18.4981 15.9412C19.7184 15.4174 20.3873 14.1385 20.1941 12.8828L21.672 12.2484C22.4493 13.2534 23.8371 13.6494 25.0574 13.1255C26.2777 12.6017 26.9466 11.3228 26.7534 10.0671L29.4602 8.9052L31.7127 14.1527L30.3178 14.7514C29.5406 13.7464 28.1527 13.3504 26.9324 13.8743C25.7121 14.3981 25.0432 15.677 25.2364 16.9327L18.511 19.8197C17.7338 18.8146 16.3459 18.4187 15.1257 18.9425C13.9054 19.4663 13.2365 20.7452 13.4297 22.0009L12.0348 22.5997L9.78222 17.3522L11.1771 16.7534ZM5.18752 13.887L6.49938 13.3238L16.0727 35.6255L14.7608 36.1887L5.18752 13.887ZM43.8298 26.8176L12.8698 40.1076L12.3067 38.7958L43.2667 25.5058L43.8298 26.8176Z"
					fill="white"
				/>
			</svg>
			<svg
				class="lamp icon"
				width="46"
				height="48"
				viewBox="0 0 46 48"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g>
					<path
						d="M26.4306 10.3564C19.7062 8.62495 12.8272 12.6869 11.0958 19.4112C9.78214 24.513 11.7684 29.8433 16.0497 32.8487L14.3689 39.3766C14.2668 39.7733 14.5049 40.1765 14.9016 40.2786L15.6189 40.4633L15.2495 41.898C15.1474 42.2947 15.3855 42.6979 15.7821 42.8L20.0862 43.9083C20.4829 44.0104 20.8861 43.7723 20.9883 43.3756L21.3577 41.9409L22.075 42.1256C22.4717 42.2278 22.8749 41.9897 22.9771 41.593L24.6579 35.0652C29.8583 34.5011 34.1718 30.7929 35.4854 25.6912C37.2168 18.9668 33.1549 12.0878 26.4306 10.3564ZM21.0097 40.3215C20.613 40.2194 20.2098 40.4575 20.1077 40.8542L19.7383 42.2889L16.8689 41.5501L17.2383 40.1154C17.3404 39.7187 17.1024 39.3155 16.7057 39.2133L15.9883 39.0286L16.9118 35.4419L22.6506 36.9195L21.7271 40.5063L21.0097 40.3215ZM24.0229 33.6335C23.7032 33.6544 23.4335 33.8787 23.3539 34.1879L23.02 35.4849L17.2812 34.0072L17.6152 32.7103C17.695 32.4004 17.567 32.0745 17.2971 31.9017C13.2479 29.3079 11.3317 24.4362 12.5304 19.7806C14.0581 13.8475 20.128 10.2634 26.0611 11.7911C31.9943 13.3187 35.5784 19.3886 34.0507 25.3218C32.852 29.9773 28.8214 33.3178 24.0229 33.6335Z"
						fill="white"
					/>
					<path
						d="M26.8 8.92162C27.1967 9.02377 27.5999 8.78568 27.702 8.38899L28.4408 5.51961C28.543 5.12292 28.3049 4.71971 27.9082 4.61757C27.5115 4.51542 27.1083 4.75351 27.0062 5.1502L26.2673 8.01958C26.1652 8.41627 26.4033 8.81948 26.8 8.92162Z"
						fill="white"
					/>
					<path
						d="M40.6916 26.2668L37.8222 25.528C37.4255 25.4258 37.0223 25.6639 36.9202 26.0606C36.818 26.4573 37.0561 26.8605 37.4528 26.9627L40.3222 27.7015C40.7189 27.8036 41.1221 27.5655 41.2242 27.1688C41.3264 26.7721 41.0883 26.3689 40.6916 26.2668Z"
						fill="white"
					/>
					<path
						d="M9.12846 18.1397L6.25909 17.4009C5.8624 17.2988 5.45919 17.5369 5.35704 17.9335C5.2549 18.3302 5.49299 18.7335 5.88968 18.8356L8.75906 19.5744C9.15575 19.6766 9.55896 19.4385 9.6611 19.0418C9.76325 18.6451 9.52516 18.2419 9.12846 18.1397Z"
						fill="white"
					/>
					<path
						d="M38.2227 12.874L35.6717 14.3803C35.319 14.5886 35.2023 15.0419 35.4105 15.3946C35.5144 15.5705 35.6799 15.6881 35.8636 15.7354C36.0472 15.7827 36.249 15.7597 36.4249 15.6558L38.9758 14.1495C39.3285 13.9412 39.4453 13.4879 39.237 13.1352C39.0288 12.7825 38.5745 12.6663 38.2227 12.874Z"
						fill="white"
					/>
					<path
						d="M10.1563 29.4466L7.60535 30.9529C7.25265 31.1611 7.13592 31.6145 7.34418 31.9672C7.44804 32.1431 7.61358 32.2607 7.79722 32.3079C7.98086 32.3552 8.1826 32.3322 8.3585 32.2284L10.9095 30.722C11.2622 30.5138 11.3789 30.0604 11.1707 29.7077C10.9624 29.355 10.509 29.2383 10.1563 29.4466Z"
						fill="white"
					/>
					<path
						d="M31.4615 34.9322C31.2532 34.5795 30.7999 34.4628 30.4472 34.6711C30.0945 34.8793 29.9777 35.3327 30.186 35.6854L31.6923 38.2364C31.7961 38.4123 31.9617 38.5298 32.1453 38.5771C32.329 38.6244 32.5307 38.6014 32.7066 38.4975C33.0593 38.2893 33.176 37.8359 32.9678 37.4832L31.4615 34.9322Z"
						fill="white"
					/>
					<path
						d="M15.1198 10.1701C15.2236 10.346 15.3892 10.4636 15.5728 10.5109C15.7565 10.5582 15.9582 10.5352 16.1341 10.4313C16.4868 10.223 16.6035 9.76969 16.3953 9.41699L14.889 6.866C14.6807 6.5133 14.2273 6.39656 13.8746 6.60483C13.5219 6.81309 13.4052 7.26645 13.6135 7.61915L15.1198 10.1701Z"
						fill="white"
					/>
					<path
						d="M25.507 13.9431C20.7604 12.7209 15.9047 15.5881 14.6825 20.3347C14.5803 20.7314 14.8184 21.1346 15.2151 21.2368C15.6118 21.3389 16.015 21.1008 16.1172 20.7042C17.1356 16.7487 21.1822 14.3593 25.1376 15.3778C25.5343 15.4799 25.9375 15.2418 26.0397 14.8451C26.1418 14.4484 25.9037 14.0452 25.507 13.9431Z"
						fill="white"
					/>
				</g>
			</svg>
		</div>
	</div>
</template>

<style scoped lang="scss">
.Component {
	background-color: #e9407a;
	display: flex;
	padding: 16px 24px;
	justify-content: space-between;
	position: relative;
	flex-direction: column;
	z-index: 1;
	margin-top: 32px;
	//margin-bottom: 24px;
	@media (max-width: 768px) {
		flex-direction: column;
	}

	h2 {
		font-weight: bold;
		font-size: 24px;
		line-height: 140%;
		display: flex;
		align-items: center;
		color: #ffffff;
		max-width: 100px;
	}
}

.calculator {
	right: 0;
	top: 10px;
}

.lamp {
	right: 5px;
	top: 80px;
}

.icon {
	position: absolute;
	z-index: -1;
	opacity: 0.3;
}

.button {
	width: 100%;
	height: 44px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #ffffff;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
}
</style>
<script>
export default {
	name: 'Banner',

	computed: {
		olympPrefix() {
			// TEMPORARY CHANGE: PL version should use olymp.indigomental.com (no pl. prefix)
			// To revert: uncomment the lines below and remove 'return '''
			// const isPL = window.location.origin.includes('pl.indigo')
			// return isPL ? 'pl.' : ''
			return ''
		},
	},
}
</script>
